import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    input,
    OnDestroy,
    OnInit,
    output,
    viewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
    AixButtonComponent,
    AixDataTestingDirective,
    AixNotificationComponent,
    BUTTON_TYPE
} from '@trade-platform/ui-components';
import {
    BaseOrdersStoreFacade,
    isAboveTotalFileSizeLimit,
    ORDERS_STORE_FACADE
} from '@advisor-ui/orders';
import { areFormUploadsCompletedInCurrentStep } from '../utils/order-utils';
import { fileType } from '@trade-platform/lib-enums';

@Component({
    selector: 'aix-wet-sign',
    templateUrl: './wet-sign.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AixButtonComponent, AixDataTestingDirective, AixNotificationComponent]
})
export class AixOrderProcessWetSignComponent implements OnInit, OnDestroy {
    storeFacade = inject<BaseOrdersStoreFacade>(ORDERS_STORE_FACADE);
    private cd = inject(ChangeDetectorRef);

    isReadOnly = input<boolean | null | undefined>(false);
    onClickContinue = output();

    readonly formsMustBeLabeledNotification = viewChild<AixNotificationComponent>(
        'formsMustBeLabeledNotification'
    );

    unfinishedUploads = true;
    areFormsUnlabeled = false;
    isAboveTotalFileSize = false;
    subscriptions: Subscription[] = [];
    continueButtonType = BUTTON_TYPE.primary;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    ngOnInit() {
        this.subscriptions.push(
            this.storeFacade.orderSuccess$.subscribe(order => {
                this.isAboveTotalFileSize = isAboveTotalFileSizeLimit(order);
                this.unfinishedUploads = !areFormUploadsCompletedInCurrentStep(order);
                this.areFormsUnlabeled = order.files.some(
                    file => file.type === fileType.unassignedForm
                );
                this.formsMustBeLabeledNotification()?.closeNotification();
                this.cd.detectChanges();
            })
        );
    }

    onContinue() {
        if (this.areFormsUnlabeled) {
            this.formsMustBeLabeledNotification()?.openNotification();
        } else {
            this.formsMustBeLabeledNotification()?.closeNotification();
            this.onClickContinue.emit();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
